import React, { useEffect, useState } from 'react';
import { Edit, Trash2 } from 'react-feather';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
//Table ant design
import { Table } from 'ant-table-extensions';
import { CheckCircleTwoTone, SearchOutlined } from '@ant-design/icons';
import ModalDeleteCustomerUser from '../../components/Modal/ModalDeleteCustomerUser';
import { timestampToDate } from '../../common/handleTimestamp';
import {
  allCustomerInfos,
  getDataCustomers,
} from '../Customers/CustomersSlice';
import { allCustomerUsers, getDataCustomerUsers } from './CustomerUsersSlice';
import Breadcrumbs from '../../designs/Breadcrumbs/Breadcrumbs';
import { Button, Card, Col, Row } from 'react-bootstrap';
import ModalAddCustomerUsers from '../../components/Modal/ModalAddCustomerUsers';
import ModalEditCustomerUsers from '../../components/Modal/ModalEditCustomerUsers';

const CustomerUsers = (props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const token = localStorage.getItem('token');
  const dataCustomerUsers = useSelector(allCustomerUsers);
  const [isModalAddCustomerUser, setIsModalAddCustomerUser] = useState(false);
  const [isModalEditCustomerUser, setIsModalEditCustomerUser] = useState(false);

  const [curPage, setCurPage] = useState(1);
  const [pagination, setPagination] = useState({
    current: curPage,
    pageSize: 10,
    total: 10,
  });
  const [loading, setLoading] = useState(false);
  const [isDeleteCustomerUser, setIsDeleteCustomerUser] = useState(false);

  const [userId, setUserId] = useState();
  const statusCustomerUsers = useSelector(
    (state) => state.customerUsers.status
  );
  const customerId = props.match.params.customer_id;

  const allCustomer = useSelector(allCustomerInfos);

  const [customerName, setCustomerName] = useState('');
  const userStatus = useSelector((state) => state.customerUsers.status);

  useEffect(() => {
    if (statusCustomerUsers === 'loading') {
      setLoading(true);
    } else {
      setPagination({ ...pagination, total: dataCustomerUsers?.totalElements });
      setLoading(false);
    }
  }, [statusCustomerUsers]);

  if (userStatus === 'success') {
    const page = 0;
    const pageSize = 1000;
    dispatch(getDataCustomerUsers({ token, customerId, pageSize, page }));
    setLoading(false);
  }

  useEffect(() => {
    const pageSize = pagination.pageSize;
    const page = pagination.current - 1;
    dispatch(getDataCustomerUsers({ token, customerId, pageSize, page }));
  }, [dispatch]);

  useEffect(() => {
    dispatch(getDataCustomers({ token }));
  }, [dispatch, token]);

  useEffect(() => {
    const customerInfo = allCustomer.data?.filter(
      (item) => item.id.id === customerId
    )[0];
    setCustomerName(customerInfo?.name);
  }, [allCustomer]);

  const data = dataCustomerUsers?.map((item, idx) => ({
    key: idx,
    index: item.id.id,
    email: item.email,
    name: item.firstName,
    createdTime: timestampToDate(item.createdTime),
    config: item.attributes?.role?.config,
    mode: item.attributes?.role?.mode,
    operation: item.attributes?.role?.operation,
    power: item.attributes?.role?.power,
    edit: item.id.id,
  }));

  const columns = [
    {
      title: 'ID',
      dataIndex: 'index',
      key: 'index',
      width: 300,
    },
    {
      title: 'Email'.toUpperCase(),
      dataIndex: 'email',
      key: 'email',
      width: 250,
    },
    {
      title: t('name').toUpperCase(),
      dataIndex: 'name',
      key: 'name',
      width: 250,
    },
    {
      title: t('date-created').toUpperCase(),
      dataIndex: 'createdTime',
      key: 'createdTime',
      width: 250,
    },
    {
      title: t('power').toUpperCase(),
      dataIndex: 'power',
      key: 'power',
      align: 'center',
      width: 100,
      render: (e) =>
        e && (
          <CheckCircleTwoTone
            twoToneColor="#1ac427"
            style={{ fontSize: '150%' }}
          />
        ),
    },
    {
      title: t('mode').toUpperCase(),
      dataIndex: 'mode',
      key: 'mode',
      align: 'center',
      width: 100,
      render: (e) =>
        e && (
          <CheckCircleTwoTone
            twoToneColor="#1ac427"
            style={{ fontSize: '150%' }}
          />
        ),
    },
    {
      title: t('operation').toUpperCase(),
      dataIndex: 'operation',
      key: 'operation',
      align: 'center',
      width: 100,
      render: (e) =>
        e && (
          <CheckCircleTwoTone
            twoToneColor="#1ac427"
            style={{ fontSize: '150%' }}
          />
        ),
    },
    {
      title: t('config').toUpperCase(),
      dataIndex: 'config',
      key: 'config',
      align: 'center',
      width: 120,
      render: (e) =>
        e && (
          <CheckCircleTwoTone
            twoToneColor="#1ac427"
            style={{ fontSize: '150%' }}
          />
        ),
    },
    {
      title: t('edit').toUpperCase(),
      dataIndex: 'edit',
      key: 'edit',
      align: 'center',
      width: 250,
      render: (id) => (
        <>
          <Edit
            className="edit__user mr-2"
            onClick={() => {
              setIsModalEditCustomerUser(true);
              setUserId(id);
            }}
          />

          <Trash2
            className="delete__user"
            onClick={() => {
              setIsDeleteCustomerUser(true);
              setUserId(id);
            }}
          />
        </>
      ),
    },
  ];

  const handleTableChange = (pagination, filters, sorter) => {
    if (curPage !== pagination.current) {
      const pageSize = pagination.pageSize;
      const page = pagination.current - 1;
      dispatch(getDataCustomers({ token, pageSize, page }));
      setCurPage(pagination.current);
    }
    setPagination(pagination);
  };

  return (
    <section className="pcoded-main-container">
      <div className="pcoded-wrapper">
        <div className="pcoded-content">
          <div className="pcoded-inner-content">
            <div className="main-body">
              <div className="page-wrapper">
                <Breadcrumbs
                  floor={[
                    { name: t('customer'), href: 'goBack' },
                    { name: customerName, href: 'null' },
                    {
                      name: t('management'),
                      href: 'null',
                      style: {
                        fontStyle: 'italic',
                        color: 'gray',
                        fontWeight: 'bold',
                      },
                    },
                  ]}
                />
                <div className="page-header">
                  <div className="page-block"></div>
                </div>
                <Row>
                  <Col>
                    <Card>
                      <Card.Header>
                        <h5>{t('management')}</h5>
                      </Card.Header>
                      <Card.Body>
                        <Button
                          variant="primary"
                          onClick={() => setIsModalAddCustomerUser(true)}
                          style={{ margin: '0 15px 10px', float: 'left' }}
                        >
                          + {t('add-new')}
                        </Button>
                        <Table
                          columns={columns}
                          dataSource={data}
                          pagination={pagination}
                          loading={loading}
                          onChange={handleTableChange}
                          scroll={{ x: true }}
                          searchableProps={{
                            inputProps: {
                              placeholder: t('search-table'),
                              prefix: <SearchOutlined />,
                              style: {
                                maxWidth: '350px',
                                padding: '6px',
                                borderRadius: '5px',
                              },
                            },
                            fuzzySearch: true,
                          }}
                        />
                        <ModalDeleteCustomerUser
                          show={isDeleteCustomerUser}
                          setShow={setIsDeleteCustomerUser}
                          userId={userId}
                          customerId={customerId}
                        />
                        <ModalAddCustomerUsers
                          show={isModalAddCustomerUser}
                          setShow={setIsModalAddCustomerUser}
                          customerId={customerId}
                        />
                        <ModalEditCustomerUsers
                          show={isModalEditCustomerUser}
                          setShow={setIsModalEditCustomerUser}
                          userId={userId}
                          customerId={customerId}
                        />
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CustomerUsers;
